import styled from "styled-components";

export const Container = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	gap: 1rem;
	background: ${({ theme }) => theme.pantone656C};
	padding: 1rem;
	border-radius: 8px;
	overflow: auto;
	max-height: 96vh;
	max-height: calc(100dvh - 2rem);
	width: 100%;
	max-width: 1200px;
`;

export const AreaCloseIcon = styled.div`
	position: absolute;
	top: 1.4rem;
	right: 1.4rem;
`;

export const AreaLoading = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	min-height: 650px;
`;
